module.exports = __webpack_public_path__ + "img/knee.29956551.png";